import { render } from "./DetailImagePrize.vue?vue&type=template&id=2cbe69b8&scoped=true"
import script from "./DetailImagePrize.vue?vue&type=script&lang=js"
export * from "./DetailImagePrize.vue?vue&type=script&lang=js"

import "./DetailImagePrize.vue?vue&type=style&index=0&id=2cbe69b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbe69b8"]])

export default __exports__